import { render, staticRenderFns } from "./161.vue?vue&type=template&id=0ab48fb9&scoped=true&"
var script = {}
import style0 from "./161.vue?vue&type=style&index=0&id=0ab48fb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab48fb9",
  null
  
)

export default component.exports